import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {

  private consentCookieName = 'father-bishoy-cookie-consent';

  constructor(private cookieService: CookieService) { }

  hasConsented(): boolean {
    return this.cookieService.get(this.consentCookieName) === 'true';
  }

  setConsent(consent: boolean): void {
    this.cookieService.set(this.consentCookieName, consent.toString(), { expires: 365 });
  }

  getConsent(): string {
    return this.cookieService.get(this.consentCookieName);
  }
}
